
import { db } from './firebase';
import { collection, addDoc, getDocs, query, where, getDoc, doc } from 'firebase/firestore';
import type { Section } from '@/components/FunnelBuilder/types';
import { sectionTemplates, type SectionTemplate, type FunnelTemplate } from '@/components/FunnelBuilder/SectionTemplates/templates';
import { isSuperAdmin } from './auth';
import { User } from 'firebase/auth';

const CURRENT_VERSION = '2.0.0';

export const saveAsTemplate = async (section: Section, title: string, description: string, category: SectionTemplate['category'], user: User | null) => {
  if (!user || !isSuperAdmin(user)) {
    throw new Error('Unauthorized');
  }

  const template: Omit<SectionTemplate, 'id'> = {
    title,
    description,
    category,
    thumbnail: '/templates/default.jpg',
    blocks: section.blocks,
    isPro: true,
    createdBy: user.uid,
    createdAt: new Date().toISOString(),
  };

  const docRef = await addDoc(collection(db, 'sectionTemplates'), template);
  return { id: docRef.id, ...template };
};

export const saveFunnelAsTemplate = async (funnelData: any, title: string, description: string, user: User | null) => {
  if (!user || !isSuperAdmin(user)) {
    throw new Error('Unauthorized');
  }

  const template: Omit<FunnelTemplate, 'id'> = {
    title,
    description,
    thumbnail: '/templates/default.jpg',
    isPro: true,
    createdBy: user.uid,
    createdAt: new Date().toISOString(),
    data: funnelData,
    version: CURRENT_VERSION
  };

  const docRef = await addDoc(collection(db, 'funnelTemplates'), template);
  return { id: docRef.id, ...template };
};

export const getAllTemplates = async () => {
  const sectionTemplatesSnapshot = await getDocs(collection(db, 'sectionTemplates'));
  const customTemplates = sectionTemplatesSnapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data()
  })) as SectionTemplate[];

  return [...sectionTemplates, ...customTemplates];
};

export const getAllFunnelTemplates = async () => {
  const funnelTemplatesSnapshot = await getDocs(collection(db, 'funnelTemplates'));
  return funnelTemplatesSnapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data(),
    version: doc.data().version || '1.0.0'
  })) as FunnelTemplate[];
};
